/**
 * Application constants
 */

// Brand Colors
export const BRAND_COLORS = {
  PRIMARY_BLUE: '#4670BF',
  LIGHT_BLUE: '#81A3F8',
  GRAY_BLUE: '#B5CEFC',
  DARK_BLUE: '#203F72',
  GRAY: '#5A667A',
  DARK: '#21272A',
  LIGHT_GRAY: '#F5F6FF',
  WHITE: '#FFFFFF',
} as const;

// Typography
export const TYPOGRAPHY = {
  FONT_FAMILY: 'Albert Sans',
  SIZES: {
    HEADING_1: 'text-4xl font-extrabold',
    HEADING_2: 'text-3xl font-bold',
    HEADING_3: 'text-xl font-bold',
    BODY: 'text-base',
    SMALL: 'text-sm',
  },
  WEIGHTS: {
    MEDIUM: 'font-medium',
    BOLD: 'font-bold',
    EXTRABOLD: 'font-extrabold',
  },
} as const;

// Layout
export const LAYOUT = {
  CONTAINER_MAX_WIDTH: 'max-w-7xl',
  BORDER_RADIUS: {
    SMALL: '8px',
    MEDIUM: '20px',
    LARGE: '40px',
    XLARGE: '70px',
  },
  SPACING: {
    SECTION_PADDING: 'py-20',
    CONTAINER_PADDING: 'px-4 sm:px-6 lg:px-8',
  },
} as const;

// Animation Durations
export const ANIMATIONS = {
  DURATION: {
    FAST: 0.2,
    NORMAL: 0.4,
    SLOW: 0.6,
  },
  DELAY: {
    SHORT: 0.1,
    MEDIUM: 0.2,
    LONG: 0.4,
  },
} as const;

// API Endpoints
export const API_ENDPOINTS = {
  HEADER: '/api/header',
  AUTH: {
    LOGIN: '/api/v1/auth/login',
    REGISTER: '/api/v1/auth/register',
    VERIFY: '/api/v1/auth/verify',
    REFRESH: '/api/v1/auth/refresh',
    LOGOUT: '/api/v1/auth/logout',
  },
  CATEGORIES: '/api/v1/categories',
  EVENTS: '/api/v1/events',
  SERVICES: '/api/v1/services',
  FILTERS: '/api/v1/site-data/filters',
} as const;

// Routes
export const ROUTES = {
  HOME: '/',
  EVENTS: '/find-events',
  SERVICES: '/find-services',
  ABOUT: '/about',
  LOGIN: '/login',
  REGISTER: '/register',
  SIGNUP: '/register', // Alias for register
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  FORGOT_PASSWORD: '/forgot-password',
} as const;

// Accessibility
export const ACCESSIBILITY = {
  AA_PLUS: 'AA+',
  FONT_SIZE_SMALL: 'A-',
  FONT_SIZE_MEDIUM: 'AA',
  FONT_SIZE_LARGE: 'AA+',
} as const;

// Validation
export const VALIDATION = {
  PASSWORD_MIN_LENGTH: 6,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 50,
} as const;

// Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
  USER_PREFERENCES: 'userPreferences',
  LANGUAGE: 'language',
} as const;
